import React, { useEffect, useMemo, useState } from 'react';
import styles from './login.module.less';
import { Input, Button } from 'antd';
import EmailIcon from '../../../images/Email.png';
import { useDispatch, useSelector } from 'react-redux';
import {
  loginSecondStepFetch,
  resendOTPCodeFetch,
} from '@Modules/account/auth/AuthActions';
import { useLocation } from 'react-router-dom';
import { useCounter } from '../../../hook/useCounter';
import { detectFlavor } from '@Utils/FlavorUtils';
import { history } from '@Redux/store';
import qs from 'qs';

const LoginVerification = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const { otpId, remember } = useMemo(() => {
    return qs.parse(search, { ignoreQueryPrefix: true });
  }, [search]);

  const [verificationCode, setVerificationCode] = useState('');
  const { loginSecondStepStatus } = useSelector((state) => state.account.auth);

  useEffect(() => {
    if (!otpId) {
      history.replace('/auth/login');
    }
  }, [otpId]);

  const handleResendOtpBtn = () => {
    dispatch(resendOTPCodeFetch(otpId));
  };

  const { isCounting, timer, reset } = useCounter({
    duration: 180,
    immediate: true,
    onReset: handleResendOtpBtn,
  });

  const verifyOtpCode = () => {
    const params = new URLSearchParams(search);

    const returnUrl = params.get('returnUrl');

    let body = {
      rememberMe: remember === 'true',
      otpId: otpId,
      otpCode: verificationCode,
    };

    dispatch(loginSecondStepFetch({ body, returnUrl }));
  };

  const flavor = detectFlavor();

  return (
    <>
      <div className={styles[`home-page-${flavor}`]}>
        <div className={styles[`home-page__box-${flavor}`]}>
          <div
            className={`${styles['home-page__left-section']} ${
              styles[`home-page__left-section-${flavor}`]
            }`}
          >
            <div className={styles.form}>
              <div className={styles.email_verification__logo}>
                <img src={EmailIcon} />
              </div>
              <div className={styles.form__email__title}>
                We&apos;ve just sent a verification code to your inbox. Please
                check your email and enter the verification code
              </div>
              <div className={styles.form__item}>
                <div className={styles.form__title}>Verification Code</div>
                <Input
                  id="verification-code"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  className={styles.form__input}
                />
              </div>
              <div className={styles['form__button-container']}>
                <Button
                  id="verification-confirm"
                  loading={loginSecondStepStatus?.loading}
                  onClick={verifyOtpCode}
                  type="primary"
                  shape="round"
                  className={styles.form__login}
                  data-badge="inline"
                  disabled={
                    loginSecondStepStatus?.disabled || verificationCode === ''
                  }
                >
                  CONFIRM
                </Button>
                <div className={styles.form__singup}>
                  <span className={styles.form__singup__description}>
                    Didn&apos;t get the code?
                  </span>
                  <span
                    className={
                      isCounting
                        ? styles.disabled_resend__button
                        : styles.enabled_resend__button
                    }
                    onClick={isCounting ? () => {} : reset}
                  >
                    Resend
                  </span>
                  {isCounting && (
                    <span className={styles.timer}>{`(${timer})`}</span>
                  )}
                </div>
                <Button
                  type="link"
                  onClick={() => history.push('/auth/login')}
                  style={{ fontWeight: 'bold' }}
                >
                  Back To Login
                </Button>
              </div>
            </div>
          </div>
          <div
            id={`login-side-${flavor}`}
            className={styles[`home-page__right-section-${flavor}`]}
          />
        </div>
      </div>
    </>
  );
};

export { LoginVerification };
